import React, { useEffect, useState } from 'react';
import { AppLayout } from '../../layouts/AppLayout';
import { AppRoutes } from '../../routes/AppRoutes';
import { useAuthInitialization } from '../../hooks/useAuthInitialization';
import { SubscriptionMonitor } from './SubscriptionMonitor';
import { cleanupAllTopicFilters } from '../../contexts/TopicFiltersContext';

export function AppRoot() {
  const { loading, isInitialized } = useAuthInitialization();
  const [wasInitialized, setWasInitialized] = useState(false);

  // Track when auth has been initialized
  useEffect(() => {
    if (isInitialized) {
      setWasInitialized(true);
    }
  }, [isInitialized]);

  // Ensure wasInitialized stays true if the app becomes visible again
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && isInitialized) {
        setWasInitialized(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [isInitialized]);

  // Cleanup all topic filters when app unmounts
  useEffect(() => {
    return () => {
      cleanupAllTopicFilters();
    };
  }, []);

  // Only hide the app during initial loading
  // Once auth has been initialized once, always show the app
  if (!wasInitialized && loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-pulse bg-blue-500 w-8 h-8 rounded-full"></div>
      </div>
    );
  }

  return (
    <AppLayout>
      <AppRoutes />
      {/* Include the Subscription Monitor (only visible in dev mode when Alt+S is pressed) */}
      <SubscriptionMonitor />
    </AppLayout>
  );
}
